<h1 mat-dialog-title *ngIf="TitleText">
    <span>{{ TitleText }}</span>
    <mat-icon *ngIf="ShowIcon" [color]="IconColor">{{ IconName }}</mat-icon>
</h1>
<div mat-dialog-content>
    <h4 [innerHTML]="MessageText"></h4>
    <p [innerHTML]="SubMessageText"></p>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="basic" (click)="CancelHandler()">{{ CancelText }}</button>
    <button mat-raised-button color="warn" (click)="OKHandler()" [disabled]="DisableDelete">
        <span *ngIf="DisableDelete">{{ data.DelayDelete }}</span>
        {{ OKText }}</button>
</div>